module.exports = __webpack_public_path__ + "static/img/2021_ChristmasMenu.f8a7038.jpg";